export {
	createCustomTip,
	CUSTOM_TIP_MAX_AMOUNT,
	CUSTOM_TIP_MAX_DECIMAL_PLACES,
	normalizeCustomTipInput,
} from './custom-tip.domain';
